import { clientProductCode } from "../config/config";
import { functions } from '../firebase/Firebase';
import InitializeResult from '../models/InitializeResult';

export const AppActionTypes = {
    Initialize: 'Initialize',
    InitializeDone: 'InitializeDone',
};

function initializeFunction() {
    return functions.httpsCallable('neofelisInitialize');
}

export const initialize = () => {
    return async (dispatch, getState) => {
        try {
            const appState = getState().appState;
            const initializeCompletedInState = appState.initializeCompleted;
            if (initializeCompletedInState === false) {
                return;
            }

            dispatch({
                type: AppActionTypes.Initialize,
            });

            const callable = initializeFunction();
            const data = {
                clientProductCode: clientProductCode,
            };

            const result = await callable(data);

            dispatch({
                type: AppActionTypes.InitializeDone,
                initializeResult: InitializeResult.deserialize(result.data),
            });
        } catch (error) {
            dispatch({
                type: AppActionTypes.InitializeDone,
                error: error,
            });
        }
    }
};
